import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (ready && user) navigate("/admin"); }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-secondary/40">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-background border border-border p-10" data-testid="admin-login-card">
        <Logo />
        <h1 className="text-3xl mt-8 mb-2">Admin Access</h1>
        <p className="text-sm text-muted-foreground mb-8">Sign in to manage your catalog and orders.</p>
        <form onSubmit={submit} className="flex flex-col gap-5">
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input"
              className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-accent transition-colors" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input"
              className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-accent transition-colors" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-button"
            className="mt-2 rounded-full bg-foreground text-background py-4 text-sm uppercase tracking-widest hover:bg-accent transition-colors duration-300 disabled:opacity-50">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
